const mEditionBillingMyChargesInvoice = {
  mEditionBillingMyChargesInvoice: {
    alerts: {
      download: {
        error: 'No hay cobros para exportar',
        success: 'Downloaded...'
      }
    }
  }
}
export default mEditionBillingMyChargesInvoice
